import { combineReducers } from 'redux';
import assessmentReducer from './assessmentReducer';
import authReducer from './authReducer';
import userReducer from './userReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  assessment: assessmentReducer,
});

export default rootReducer;
